import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Box, CircularProgress, InputAdornment, Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Copyright from "../components/Copyright";
import { IconButton } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { SERVER_BASE_ADDRESS } from "../globals/const";
import { saveAuth } from "../globals/authentication";
import { useTranslation } from "react-i18next";
import { useAlert } from "../components/Alert";

import BackButtonIcon from "../assets/Icon/BackButtonIcon.png";
import FarmAppLogo from "../assets/logo/FarmAppLogo.png";
import PasswordVisibility from "../components/PasswordVisibility";
import { getCouponUser } from "../api/franchise";
import { handleMobileKeyDown } from "../globals/utils";
import { Phone as PhoneIcon, Email as EmailIcon } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
  root: {
    maxHeight: "100vh",
    margin: "auto",
    padding: "20px !important",
  },
  signUpTitle: {
    fontSize: "12px !important",
    textAlign: "center",
    marginTop: "20px !important",
    lineHeight: "40px !important",
  },
  subText: {
    fontSize: "12px !important",
    color: "#827F7F",
    fontWeight: "400 !important",
    marginLeft: "8px !important",
  },
}));
export default function Register() {
  const classes = useStyles();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("referral_code");

  const [referrer, setReferrer] = useState(null);
  const [creds, setCreds] = useState({
    role: "FARMER",
  });
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  function setCredField(key, value) {
    setCreds((prevCreds) => ({
      ...prevCreds,
      [key]: value,
    }));
  }

  function submitHandler(event) {
    event.preventDefault();
    setLoading(true);
    creds.username = creds.email;
    creds.tenant_code = "ASQI";
    creds.referral_code = referralCode;
    axios.defaults.headers = { "Content-Type": "application/json" };
    axios
      .post(SERVER_BASE_ADDRESS + "/auth/register", creds)
      .then((res) => {
        // saveAuth(res.data);
        // window.open("/", "_self");
        if (res && res.data) {
          saveAuth(res.data);
          setTimeout(() => {
            window.open("/", "_self");
            setLoading(false);
          }, 2000);
        }
      })
      .catch((e) => {
        setLoading(false);
        showAlert("error", e.response?.data?.message || "An error occurred");
      });
  }

  useEffect(() => {
    const fetchReferrer = async () => {
      const user = await getCouponUser(referralCode);
      if (user) setReferrer(user);
    };

    if (referralCode) {
      fetchReferrer();
    }
  }, [referralCode]);

  return (
    <Container component="main" maxWidth="xs">
      <Helmet>
        <title>Sign Up - Farmapp</title>
      </Helmet>
      <IconButton
        edge="start"
        sx={{ mx: "0.1rem", marginTop: "10px" }}
        aria-label="back"
        onClick={() => navigate(-1)}
      >
        <img src={BackButtonIcon} />
      </IconButton>
      <CssBaseline />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <img
          alt="asqi"
          src={FarmAppLogo}
          style={{ width: "206", height: "170px" }}
        />

        {referralCode ? (
          <>
            <form
              style={{
                width: "100%",
                marginTop: 25,
              }}
              onSubmit={submitHandler}
            >
              <Typography variant="h6" align="center" mb={1}>
                {t("Create a new Farmapp account")}
              </Typography>
              {referrer && (
                <Typography variant="body1" align="center" mb={4}>
                  {t("You were referred by")} {referrer?.full_name}{" "}
                </Typography>
              )}

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="fname"
                    name="firstName"
                    variant="outlined"
                    required
                    fullWidth
                    id="firstName"
                    label={t("First Name")}
                    onChange={(event) =>
                      setCredField("first_name", event.target.value)
                    }
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="lastName"
                    label={t("Last Name")}
                    name="lastName"
                    onChange={(event) =>
                      setCredField("last_name", event.target.value)
                    }
                    autoComplete="lname"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl variant="outlined" fullWidth required>
                    <InputLabel id="role-label">Role</InputLabel>
                    <Select
                      labelId="role-label"
                      id="role"
                      name="role"
                      onChange={(event) =>
                        setCredField("role", event.target.value)
                      }
                      label="Role"
                      value={creds.role}
                      disabled={!!referralCode}
                    >
                      <MenuItem value="FARMER">{t("Farmer")}</MenuItem>
                      <MenuItem value="FPO">{t("FPO")}</MenuItem>
                      {/* <MenuItem value="LENDER">{t("Lender")}</MenuItem> */}
                      <MenuItem value="AUDITOR">{t("Auditor")}</MenuItem>
                      <MenuItem value="FPO_AGGREGATOR">
                        {t("FPO Aggregator")}
                      </MenuItem>
                      <MenuItem value="BUYER">{t("Buyer")}</MenuItem>
                      <MenuItem value="SPONSOR">{t("Sponsor")}</MenuItem>
                      <MenuItem value="VERIFIER">{t("Verifier")}</MenuItem>
                      {/* <MenuItem value="AGRO_EXPERT">{t("Agro Expert")}</MenuItem> */}
                      <MenuItem value="SERVICE_PROVIDER">
                        {t("Service Provider")}
                      </MenuItem>
                      <MenuItem value="PROGRAM_MANAGER">
                        {t("Program Manager")}
                      </MenuItem>
                      <MenuItem value="POP_MANAGER">
                        {t("POP Manager")}
                      </MenuItem>
                      <MenuItem value="PLANT_INCHARGE">
                        {t("Plant Incharge")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    type="tel"
                    required
                    label={t("Mobile")}
                    onChange={(event) =>
                      setCredField("mobile", event.target.value)
                    }
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                    }}
                    onKeyDown={handleMobileKeyDown}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">+91</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    label={t("Password")}
                    type={showPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <PasswordVisibility
                          showPassword={showPassword}
                          setShowPassword={setShowPassword}
                        />
                      ),
                    }}
                    onChange={(event) =>
                      setCredField("password", event.target.value)
                    }
                  />
                </Grid>
                <hr />
              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 2, color: "#FFFFFF" }}
              >
                {loading ? (
                  <CircularProgress size={28} style={{ color: "white" }} />
                ) : (
                  t("Sign Up")
                )}{" "}
              </Button>
              <div>
                <Typography className={classes.signUpTitle}>
                  {t("Already have an account? ")}
                  <Link to="/login" style={{ color: "#1F5674" }}>
                    {t("Sign in")}
                  </Link>
                </Typography>
              </div>
            </form>
          </>
        ) : (
          <>
            <Typography variant="h6" align="center" mb={2} mt={2}>
              {t("To create an account")} <br /> {t("please contact our team.")}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: 1,
                alignItems: "center",
                width: "100%",
              }}
            >
              <Paper
                elevation={2}
                component="a"
                sx={{
                  p: 2,
                  background:
                    "linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)",
                  width: "100%",
                  maxWidth: 300,
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={() => window.open("tel:+919820893430")}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  mb={0.5}
                >
                  <PhoneIcon sx={{ color: "#1f5674", mr: 1 }} />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 700,
                      color: "#1f5674",
                      fontSize: "0.95rem",
                    }}
                  >
                    +91-9820893430
                  </Typography>
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#444",
                    textAlign: "center",
                    display: "block",
                    mt: 0.5,
                    fontSize: "0.75rem",
                  }}
                >
                  Call us directly
                </Typography>
              </Paper>

              <Paper
                elevation={2}
                component="a"
                sx={{
                  p: 2,
                  background:
                    "linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%)",
                  width: "100%",
                  maxWidth: 300,
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={() => window.open("mailto:connect@asqi.in")}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  mb={0.5}
                >
                  <EmailIcon sx={{ color: "#1f5674", mr: 1 }} />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 700,
                      color: "#1f5674",
                      fontSize: "0.95rem",
                    }}
                  >
                    connect@asqi.in
                  </Typography>
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#444",
                    textAlign: "center",
                    display: "block",
                    mt: 0.5,
                    fontSize: "0.75rem",
                  }}
                >
                  Send us an email
                </Typography>
              </Paper>
            </Box>
          </>
        )}
      </div>
      {/* <Box sx={{ padding: "20px" }}>
        <Grid
          container
          sx={{ display: "flex", justifyContent: "center", margin: "auto" }}
        >
          <Grid item xs={4}>
            <Divider
              style={{
                marginTop: "10px",
                width: "100px",
                border: "1px solid #C9ADAD",
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.subText}>
              {t("Sign in with")}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Divider
              style={{
                marginTop: "10px",
                width: "109px",
                border: "1px solid #C9ADAD",
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          mt={2}
          sx={{ display: "flex", justifyContent: "center", margin: "auto" }}
        >
          <Grid item xs={3}>
            <IconButton>
              <img src={GoogleLogo} />
            </IconButton>
          </Grid>
          <Grid item xs={3}>
            <IconButton>
              <img src={AppleLogon} />
            </IconButton>
          </Grid>
          <Grid item xs={3}>
            <IconButton>
              <img src={TwitterLogo} />
            </IconButton>
          </Grid>
          <Grid item xs={3}>
            <IconButton>
              <img src={FacebookLogo} />
            </IconButton>
          </Grid>
        </Grid>
      </Box> */}
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}
